import { action } from 'satcheljs';
import BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Action to create a booking service in the store.
 */
let createService = action('CREATE_PBP_SERVICE', (service: BookingService) => ({
    service,
}));

export default createService;
